import React from "react";
import defaultIconSettings from "./defaultIconSettings";

const LocationIcon = ({
    color = defaultIconSettings.color,
    size = defaultIconSettings.size,
    className = defaultIconSettings.className,
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 384 512"
            style={{ height: size, width: size }}
            className={className}
        >
            <path
                fill={color}
                d="M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0zM192 256c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"
            />
        </svg>
    );
};

export default LocationIcon;
